var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormsCheckEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "#10141B",
    stroke: "#00BB00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.628 5.70553C11.7907 5.86825 11.7907 6.13207 11.628 6.29479L7.04463 10.8781C6.88191 11.0408 6.61809 11.0408 6.45537 10.8781L4.37204 8.79479C4.20932 8.63207 4.20932 8.36825 4.37204 8.20554C4.53476 8.04282 4.79858 8.04282 4.96129 8.20554L6.75 9.99424L11.0387 5.70553C11.2014 5.54282 11.4652 5.54282 11.628 5.70553Z",
    fill: "#00BB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsCheckEnabled);
export default __webpack_public_path__ + "static/media/formsCheckEnabled.449954a4b4ea235ba7739b5f3a962a51.svg";
export { ForwardRef as ReactComponent };